import React from 'react'
import styled from 'styled-components'
import {Layer} from 'grommet/components/Layer'
import {_L, useLocaleState} from '../../context/LocaleContext'

export const CONFIRM_YES = 'CONFIRM_YES'
export const CONFIRM_NO = 'CONFIRM_NO'

const Confirm = ({isOpen, onClose, onConfirm, title, message}) => {
  const localeState = useLocaleState()
  return isOpen ? (
    <StyledLayer
      position="center"
      responsive={false}
      modal
      onClickOutside={onClose}
      onEsc={onClose}
    >
      <ConfirmContainer>
        <StyledTitle>{title}</StyledTitle>
        <StyledMessage>{message}</StyledMessage>
        <ButtonContainer>
          <StyledButton onClick={() => onConfirm(CONFIRM_NO)}>
            {_L({key: 'No', localeState})}
          </StyledButton>
          <StyledButton primary onClick={() => onConfirm(CONFIRM_YES)}>
            {_L({key: 'Yes', localeState})}
          </StyledButton>
        </ButtonContainer>
      </ConfirmContainer>
    </StyledLayer>
  ) : null
}

export default Confirm

Confirm.defaultProps = {
  isOpen: false,
  title: '',
  message: ''
}

const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  min-height: 160px;
  width: 400px;
  background-color: white;
  border-radius: 6px;
  border-color: white;

  @media (max-width: 420px) {
    width: calc(100vw - 100px);
  }
`

const StyledLayer = styled(Layer)`
  border-radius: 6px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 8px;
  flex: 1;
  height: 44px;
`
const StyledButton = styled.button`
  background: ${props => (props.primary ? '#3395fe' : '#ffffff')};
  color: ${props => (props.primary ? '#ffffff' : '#3395fe')};
  height: 34px;
  width: 60px;
  font-size: 16px;
  font-weight: 400;
  padding-top: 0;
  text-align: center;
  border-radius: 6px;
  margin-left: 8px;
  border: 1px solid #3395fe;
`

const StyledTitle = styled.div`
  font-weight: 700;
  height: 40px;
  font-size: 16px;
  flex: 1;
  padding: 10px;
  border-bottom: 1px solid #f3f5fb;
  user-select: none;
`

const StyledMessage = styled.div`
  font-size: 14px;
  flex: 1;
  height: 100%;
  padding: 10px;
  border-bottom: 1px solid #f3f5fb;
  user-select: none;
`
